((document) => {
    [].slice.call(document.querySelectorAll('input[type="password"]')).map(function (el: HTMLInputElement) {
        const icon = document.createElement('i');
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'btn btn-outline-secondary border-input show-password'
        btn.style.borderLeftWidth = '0px';
        btn.tabIndex = -1;
        btn.appendChild(icon);
        btn.addEventListener('click', function () { render(el, el.type === 'password'); });

        el.parentElement!.appendChild(btn);

        const render = function (el: HTMLInputElement, show: boolean) {
            el.type = show ? 'input' : 'password';
            icon.className = 'fas fa-fw fa-' + (show ? 'eye-slash' : 'eye');
            btn.title = (show ? 'Hide' : 'Show') + ' password'
        };

        render(el, false);
    });
})(document);